import Handsontable from "handsontable";
import Core from "handsontable/core";
import { CellProperties } from "handsontable/settings";
import { MatrixParameterValue } from "../interfaces/MatrixInputCell";

const customHeaderRenderer = (
  instance: Core,
  td: HTMLTableCellElement,
  rowIndex: number,
  colIndex: number,
  prop: string | number,
  cell: MatrixParameterValue,
  cellProperties: CellProperties,
) => {
  Handsontable.renderers.TextRenderer.apply(instance, [instance, td, rowIndex, colIndex, prop, cell, cellProperties]);
  td.style.backgroundColor = "#f0f0f0";
  td.style.color = "#222";
  td.style.fontWeight = "400";
  td.style.height = "2rem";
  td.style.textAlign = "left";
  td.style.verticalAlign = "top";
};

export default customHeaderRenderer;
